// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @20.06.2017 14:23:48
import { CommArgs_abstract } from './../../abstract/SagaBase/Defines/CommArgs_abstract';
export class CommArgs extends CommArgs_abstract {}
